<template>

  <div
      :class="'hm-cell hm-cell'+ (!cell.stats.total?'--zero':cell.stats.total<2?'--low':getCellStyle(cell.stats.total).invert?'--inverted':'')"
      :data-topic-l1="cell.topic.label" :data-step="cell.step.slug"
      :style="getCellStyle(cell.stats.total)"
      @click="cell.stats.total?openModal(cell.step, cell.topic, cell.stats):()=>{}"
      @mouseenter="scheduleTooltip"
      @mousemove="positionTooltip"
      @mouseleave="hideTooltip"
      :ref="'cell_'+index"
  >
    <span v-if="cell.stats.hypothesis" class="hypothesis text-white"><i class="bi bi-asterisk"></i></span>
    <div v-if="!cell.stats.total" class="hm-cell__count">—</div>
    <template v-else>
      <div class="hm-cell__count">{{ cell.stats.total }}</div>
      <div
           v-tooltip="`Предыдущее значение ${cell.stats.prev} за период ${period}`"
          :class="'hm-cell__delta hm-cell__delta'+(cell.stats.deltaPct>0?'--up':cell.stats.deltaPct<0?'--down':'')">
        {{ fmtDelta(cell.stats.deltaPct) }}
      </div>
    </template>

  </div>


</template>

<script>

export default {
  name: 'HmCell',
  data() {
    return {
      tooltipTimer: null,
      tooltipEl: document.getElementById('tooltip')
    }
  },
  computed: {},
  props: {
    palettes: {
      type: Object,
      default: () => {
      }
    },
    heatmapColorLevels: {
      type: Object,
      default: () => {
      }
    },
    index: {
      type: Number,
      default: 0
    },
    period: {
      type: String,
      default: ""
    },
    cell: {
      type: Object,
      default: () => {
      }
    },
    filters: {
      type: Object,
      default: () => {
      }
    },
    fmtDelta: {
      type: Function,
      default: () => {
      }
    },
    openModal: {
      type: Function,
      default: () => {
      }
    },
  },
  mounted() {
  },
  methods: {
    colorByHeatmapLevel(level) {
      const palette = this.palettes[this.filters.tone];
      const colors = [...palette.buckets.map(b => b.background), palette.top];
      const safeLevel = Math.max(0, Math.min(4, Number(level) || 0));
      return {bg: colors[safeLevel], inverted: safeLevel >= 3};
    },
    getCellStyle(value) {
      let bucket  = this.colorByHeatmapLevel(this.heatmapColorLevels.get(value));
      // let bucket = this.getPalettes(value)
      // if (!bucket) bucket = {background: this.palettes[this.filters.tone].top, color: '#ffffff', invert: true}
      return {background: bucket.bg, invert: bucket.inverted}
    },
    hideTooltip() {
      clearTimeout(this.tooltipTimer);
      this.tooltipEl.classList.remove('tooltip--visible');
    },
    scheduleTooltip(el, evt) {
      clearTimeout(this.tooltipTimer);
      if (this.cell.stats.total) {
        this.tooltipTimer = setTimeout(() => {
          this.showTooltip(el);
          this.positionTooltip(evt);
        }, 380);
      }
    },
    positionTooltip(evt) {
      if (evt) {
        if (!this.tooltipEl.classList.contains('tooltip--visible')) return;
        const padding = 12;
        const rect = this.tooltipEl.getBoundingClientRect();
        let x = evt.clientX + 16;
        let y = evt.clientY + 16;
        if (x + rect.width + padding > window.innerWidth) {
          x = evt.clientX - rect.width - 16;
        }
        if (y + rect.height + padding > window.innerHeight) {
          y = evt.clientY - rect.height - 16;
        }
        this.tooltipEl.style.left = x + 'px';
        this.tooltipEl.style.top = y + 'px';
      }
    },
    showTooltip(el) {

      const channels = this.cell.stats?.channels
      const l2s = this.cell.stats?.topics;

      let groupsHtml = '';

      if (channels?.length > 0) {
        groupsHtml += `
          <div class="tooltip__group">
            <div class="tooltip__group-label">Каналы взаимодействия</div>
            ${channels.map(c => `
              <div class="tooltip__row">
                <span class="tooltip__row-name">${c.label}</span>
                <span class="tooltip__row-val">${this.$pluralise(c.total, ['отзыв', 'отзыва', 'отзывов'])}</span>
              </div>
            `).join('')}
          </div>
        `;
      }

      if (l2s?.length > 0) {
        groupsHtml += `
          <div class="tooltip__group">
            <div class="tooltip__group-label">Характеристики темы</div>
            ${l2s.map(l => `
              <div class="tooltip__row">
                <span class="tooltip__row-name">${l.label}</span>
                <span class="tooltip__row-val">${this.$pluralise(l.total, ['отзыв', 'отзыва', 'отзывов'])}</span>
              </div>
            `).join('')}
          </div>
        `;
      }

      this.tooltipEl.innerHTML = `
        <div class="tooltip__title">
          <span style="display:inline-block;width:8px;height:8px;border-radius:2px;background:${this.cell.topic.color};margin-right:6px;vertical-align:middle;"></span>
          ${this.cell.topic.ui_label}
        </div>
        <div class="tooltip__sub">${this.cell.step.ui_label} · ${this.$pluralise(this.cell.stats?.total, ["отзыв", "отзыва", "отзывов"])}</div>
        <div class="tooltip__hint">${this.cell.step.ui_description}</div>
        ${this.cell.topic.ui_description ? `<div class="tooltip__hint">${this.cell.topic.ui_description}</div>` : ''}
        ${groupsHtml}
        <div class="tooltip__hint">Клик — посмотреть отзывы и детализацию</div>
      `;
      this.tooltipEl.classList.add('tooltip--visible');
    },
  }
}
</script>

<style lang="scss">

.ai-summary-root {
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0 0 22px;
}

.ai-summary-block {
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 20px 0 18px;
  padding: 16px 18px 18px;
  background: #fff;
  border: 1px solid #d9e2ef;
  border-left: 4px solid #2563eb;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, .04);
}

.ai-summary-kicker {
  margin-bottom: 8px;
  color: #2563eb;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.ai-summary-header {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}

.ai-summary-header h3 {
  margin: 0 0 6px;
  font-size: 18px;
  line-height: 1.25;
  color: #0f172a;
}

.ai-summary-header p {
  max-width: 900px;
  margin: 0;
  color: #526173;
  font-size: 13px;
  line-height: 1.45;
}

.ai-summary-header .ai-summary-note {
  margin-top: 6px;
  color: #667085;
  font-size: 12px;
}

.ai-summary-header span {
  white-space: nowrap;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.ai-summary-mini-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 10px;
}

.ai-summary-mini,
.ai-summary-card {
  border: 1px solid #dbe5f1;
  border-radius: 7px;
  background: #f8fbff;
}

.ai-summary-mini {
  min-height: 102px;
  padding: 12px;
}

.ai-summary-mini__title {
  display: -webkit-box;
  min-height: 38px;
  overflow: hidden;
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ai-summary-mini__metric,
.ai-summary-card__metric {
  margin-top: 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.ai-summary-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  padding: 8px 12px;
  border: 1px solid #c9d7ea;
  border-radius: 6px;
  background: #fff;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.ai-summary-expanded {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.ai-summary-expanded[hidden] {
  display: none !important;
}

.ai-summary-card {
  padding: 14px;
  background: #fff;
}

.ai-summary-card h4 {
  margin: 0 0 8px;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.35;
}

.ai-summary-card p {
  margin: 8px 0 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.5;
}

.ai-summary-card__problem {
  color: #1f2937 !important;
  font-weight: 700;
}

.ai-summary-card__cause {
  margin-top: 10px;
  padding: 10px 12px;
  border-left: 3px solid #2563eb;
  border-radius: 6px;
  background: #f8fbff;
  color: #334155;
  font-size: 12px;
  line-height: 1.5;
}

.ai-summary-card__cause strong {
  display: block;
  margin-bottom: 4px;
  color: #0f172a;
}

.ai-summary-card__cause p {
  margin: 0;
}

.ai-summary-card__list {
  margin-top: 10px;
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
}

.ai-summary-card__list strong {
  display: block;
  margin-bottom: 5px;
  color: #0f172a;
}

.ai-summary-card__list ol,
.ai-summary-card__list ul {
  margin: 0 0 0 18px;
  padding: 0;
}

.ai-summary-card__list li {
  margin: 4px 0;
}

.ai-summary-card__reviews {
  margin-top: 12px;
  padding: 7px 10px;
  border: 1px solid #d0d8e4;
  border-radius: 6px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.ai-summary-empty {
  padding: 14px;
  border: 1px dashed #cbd5e1;
  border-radius: 7px;
  background: #f8fafc;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}

@media (max-width: 720px) {
  .ai-summary-header {
    flex-direction: column;
  }
  .ai-summary-expanded {
    grid-template-columns: 1fr;
  }
}

.hypothesis {
  position: absolute;
  top: 0;
  right: 7px;
}

</style>